import { render } from "./Zone.vue?vue&type=template&id=b1215960&scoped=true"
import script from "./Zone.vue?vue&type=script&lang=js"
export * from "./Zone.vue?vue&type=script&lang=js"

import "./Zone.vue?vue&type=style&index=0&id=b1215960&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1215960"]])

export default __exports__